import BundleAccount from '@/components/Resources/Partials/BundleAccount.vue';
import Loyalty from '@/components/Resources/Partials/Loyalty.vue';
import TariffPlan from '@/components/Resources/Partials/TariffPlan.vue';
import api from '@/services/api';
import { mapGetters } from 'vuex';
import { store } from '@/store/store';

export default {
    data() {
        return {
            resources: {
                bundleAccount: { groups: [] },
                loyalty: { groups: [] },
                main: { groups: [] },
                tariffPlan: { groups: [] },
                other: { groups: [] },
            },
            tariffName: '',
            // True once a resources request has completed successfully; gates the empty-state
            // so it never flashes during loading.
            loaded: false,
        };
    },

    components: {
        BundleAccount,
        Loyalty,
        TariffPlan,
    },

    computed: {
        ...mapGetters({
            locale: 'locale',
            contract: 'contract/contract',
        }),

        /**
         * Whether any rendered resource bucket has items. MAIN is intentionally excluded:
         * it holds the monetary credit, which is shown in the blue header, not in this list.
         */
        hasResources() {
            const hasItems = (bucket) => Boolean(bucket && bucket.groups && bucket.groups.length);

            return hasItems(this.resources.tariffPlan)
                || hasItems(this.resources.bundleAccount)
                || hasItems(this.resources.loyalty)
                || hasItems(this.resources.other);
        },
    },

    methods: {
        /**
         * Get resources for chosen contract
         */
        getResources() {
            this.loaded = false;
            this.$Progress.start();
            api.get('/api/resources-grouped')
                .then((response) => {
                    const resourcesData = response.data.body.resources;

                    // Store grouped resources directly
                    this.resources.bundleAccount = resourcesData.BUNDLE_ACCOUNT || { groups: [] };
                    this.resources.loyalty = resourcesData.LOYALTY || { groups: [] };
                    this.resources.main = resourcesData.MAIN || { groups: [] };
                    this.resources.tariffPlan = resourcesData.TARIFF_PLAN || { groups: [] };
                    this.resources.other = resourcesData.OTHER || { groups: [] };

                    this.tariffName = response.data.body.tariff_name;
                    store.dispatch('setResources', response.data.body.user);
                    this.loaded = true;
                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$toast.error(this.$i18n.t('messages.error'));
                    this.$Progress.finish();
                });
        },
    },

    /**
     * Listen for object changed for clicked contract
     */
    watch: {
        'contract.clickedContract.phoneNumber': {
            handler() {
                this.getResources();
            },
            deep: true,
        },

        locale() {
            this.getResources();
        },
    },

    mounted() {
        if (this.contract.clickedContract.isMobile) {
            this.getResources();
        }
    },
};
